<div class="container">
  <form class="form-horizontal" [formGroup]="resetForm" (ngSubmit)="resetPassword(resetForm.value)" >
    <h4>Forgotten your password?</h4>
    <h6>We will send you an email with a link to reset your password.</h6>
    <div class="form-group no-left-padding">
      <label>Email:</label>
      <div class="form-group no-left-padding">
        <input type="text" class="form-group" formControlName="Email" name="Email" />
        <em *ngIf="resetForm.controls.Email.invalid&&resetForm.controls.Email.touched" class="text-danger">Required</em>
      </div>
    </div>
    <div class="form-group no-left-padding">
    <input type="submit" value="Send me a reset link" class="btn btn-primary" /></div>
  </form>
</div>
